import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const AuthenticatedOnly = ({ component: Component, ...props }) => {
  const { loggedInUser } = useAuth();

  if (!loggedInUser) return <Navigate to="/sign-in" />;

  return <Component {...props} />;
};

export default AuthenticatedOnly;
